import { render, staticRenderFns } from "./pcPrice.vue?vue&type=template&id=9e60ea3c&scoped=true"
import script from "./pcPrice.vue?vue&type=script&lang=js"
export * from "./pcPrice.vue?vue&type=script&lang=js"
import style0 from "./pcPrice.vue?vue&type=style&index=0&id=9e60ea3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e60ea3c",
  null
  
)

export default component.exports